import { createFileRoute } from "@tanstack/react-router";
import { ShieldAlertIcon } from "lucide-react";
import { IncidentsView } from "@/components/incidents/incidents-view";
import { incidentsPageQuery, warm } from "@/lib/workspace-queries";

export const Route = createFileRoute("/_workspace/incidents/")({
  // A head start on the default view; the page renders its own skeleton.
  loader: ({ context }) => {
    warm(context.queryClient.ensureInfiniteQueryData(incidentsPageQuery({})));
  },
  component: IncidentsPage,
});

function IncidentsPage() {
  return (
    <main className="flex flex-1 flex-col p-4 md:p-6">
      <div className="mx-auto w-full max-w-6xl space-y-6">
        <div className="space-y-1">
          <p className="flex items-center gap-1.5 font-medium text-[10px] text-muted-foreground uppercase tracking-[0.25em]">
            <ShieldAlertIcon className="size-3.5" />
            Incidents
          </p>
          <h1 className="font-bold text-2xl tracking-tight">Incident log</h1>
          <p className="text-muted-foreground text-sm">
            Record and track workplace incidents, misconduct, grievances, and accidents across your
            team.
          </p>
        </div>

        <IncidentsView />
      </div>
    </main>
  );
}
